import {
  IOnPremiseManagementStatusContactsToNotifyProps,
  IOnPremiseManagementStatusContactsToNotifyUpdateParams,
} from './types';
import { api } from '../DefaultService';

export const ON_PREMISE_MANAGEMENT_ENDPOINT = 'v1/onPremiseManagementStatus';

export const getContactsToNotifyAsync = async (
  id: number,
): Promise<IOnPremiseManagementStatusContactsToNotifyProps> => {
  try {
    const response = await api.get(
      `${ON_PREMISE_MANAGEMENT_ENDPOINT}/${id}/contacts`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro na busca dos contatos.');
  }
};

export const updateContactsToNotifyAsync = async ({
  id,
  data,
}: IOnPremiseManagementStatusContactsToNotifyUpdateParams): Promise<void> => {
  try {
    await api.put(`${ON_PREMISE_MANAGEMENT_ENDPOINT}/${id}/contacts`, data);
  } catch (error) {
    throw new Error('Erro na atualização dos contatos.');
  }
};
